/** @jsxImportSource @emotion/react */
import { Button, Divider, Grid, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useState,useContext } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FullScreenLoader from '../../Components/FullScreenLoader';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { setObjections } from '../../Helper/Functions';
import PageLayout from '../Layout/PageLayout';
import { Il8nContext } from '../../Helper/i18n';


function Objection(props) {
    const [loading, setLoading] = useState(false)
    const [objectionData, setObjectionData] = useState([])
    const localeText = useContext(Il8nContext)
    const theme = useTheme()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    

    const classes = {
        leftPaper: {
            boxShadow: '0px 0px 6px 1px #f999996b',
            padding: '20px 54px'
        },
        root: {
            padding: theme.spacing(4),
            paddingRight: '0px',
            paddingLeft: '0px',
            boxShadow: '0px 0px 6px 1px #f999996b',
        },
        textGrid: {
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5),
            cursor: 'pointer'
        },
        bottomGrid: {
            padding: '0px !important',
            marginLeft: theme.spacing(1.5),
            borderBottom: '2px solid rgb(197, 196, 196)',
            marginRight: theme.spacing(6),
            marginTop: theme.spacing(1)
        },
        text: {
            color: '#969696'
        },
        text1: {
            color: '#85807a'
        },
        textValue: {
            color: '#000'
        },
        button: {
            padding: "10px 50px",
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(2.5),
            marginLeft: theme.spacing(4)
        },
        contentDiv: {
            height: '540px',
            paddingTop: theme.spacing(3),
            overflowY: 'auto',
            overflowX: 'hidden'
        },
        title: {
            color: "#2A2A2A",
            fontWeight: 600,
            textAlign: 'center'
        },
        underline: {
            borderBottom: "2px solid #F54040",
            padding: "0px 16px 8px 0px"
        },
    }

    useEffect(() => {
        localStorage.removeItem("objection")
        getKYCData()
    }, [])

    const getKYCData = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.kycData)
            .then(resp => {
                if (resp.data.success) {
                    let data = resp.data.success[0]
                    localStorage.setItem("name", data.clientFirstName + " " + (data.clientMiddleName ? data.clientMiddleName + " " : "") + data.clientLastName)
                    getObjectionData(data.kycid)
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    const getObjectionData = (kycid) => {
        axios.get(process.env.REACT_APP_API_URL + config.getObjections + kycid)
            .then(resp => {
                if (resp.data.success) {
                    setObjectionData(resp.data.success)
                    setLoading(false)
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }
    
    const handleResolveObjection = () => {
        const objectionStepCode = {
            "PAN": "/KYCVerification",
            "Pers": "/Profile",
            "Cont": "/Profile",
            "Perm": "/AddressDetails",
            "Corr": "/AddressDetails",
            "FATCA": "/AddressDetails",
            "Bank": "/BankDetails",
            "Nom": "/NomineeDetails",
            "Brok": "/PlanDetails",
            "UpDoc": "/Upload",
            "Other": "/Upload"   
        }

        let objections = [...objectionData].map(objection=>{
            objection.navigationPath = objectionStepCode[objection.objectionTypeDescription];
            objection.isNavigationDone = false;
            return objection
        })

        setObjections(objections)
        navigate(objectionStepCode[objectionData[0].objectionTypeDescription])
    }

    return (
        <>
            <PageLayout css={{ overflowY: "scroll" }} hideSidebarGrid={isSmallScreen ? true : false} calculateHeight={isSmallScreen ? true : false}>
                <Grid container spacing={4} alignItems={"flex-start"} justifyContent={"center"}>
                    <Grid item xs={12}>
                        <Typography align="center" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                            {localeText?.objectionAop}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} lg={4}>
                        <Paper elevation={2}>
                            <Grid container spacing={2} css={{padding:"20px"}}>
                                <Grid item xs={12}>
                                    <Typography variant='body1' fontWeight={"bold"}>{localStorage.getItem("name")}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='body1' ><span css={{color:"gray"}}>{"Scrutiny ID : "}</span>{objectionData[0]?.id || ""}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='body1'><span css={{color:"gray"}}>{"Date : "}</span>{(objectionData[0]?.dateString || "")}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Button css={{margin:"20px 0px"}} variant="contained" color='primary' disabled={!objectionData.length} onClick={handleResolveObjection}>
                            {localeText?.objectionResolve}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} lg={4}>
                        <Paper style={{ paddingTop: '0px' }} elevation={2}>
                            <Grid container spacing={2} css={{ padding: "20px" }}>
                                {objectionData.map((objection, i) => (
                                    <Grid item container spacing={2} id={i} onClick={() => "handleEdit(objection, i)"} css={{ padding: "20px" }}>
                                        <Grid item xs={12}>
                                            <Typography variant='body1'><span css={{color:"gray"}}>{"Objection Name : "}</span><span css={{ fontWeight: "bold" }}>{objection.objectionTypeCode}</span></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant='body1'><span css={{color:"gray"}}>{"Description : "}</span><span>{objection.objectionDescription}</span></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant='body1'><span css={{color:"gray"}}>{"Remark : "}</span><span>{objection.remark}</span></Typography>
                                        </Grid>
                                        {i!=objectionData.length-1 && <Grid item xs={12} >
                                            <Divider />
                                        </Grid>}
                                    </Grid>
                                ))}
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </PageLayout>

            {loading && <FullScreenLoader />}
        </>
    )
}

export default Objection;